import type { GaranDefaultProps } from '../../garan.types';

/**
 * Hidden descriptive text used for screen readers and accessibility.
 */
export const Description = ({
  localizedDescription,
}: Required<Pick<GaranDefaultProps, 'localizedDescription'>>) => (
  <span className="sr-only">{localizedDescription}</span>
);
